import { render, staticRenderFns } from "./AlarmTagSetup.vue?vue&type=template&id=004a58b6&scoped=true"
import script from "./AlarmTagSetup.vue?vue&type=script&lang=ts"
export * from "./AlarmTagSetup.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "004a58b6",
  null
  
)

export default component.exports